export type EnvRule = {
  required?: boolean
  /** Значение должно парситься как URL. */
  uri?: boolean
}

/**
 * Схема раньше описывалась через Joi. Ради проверки двух обязательных строк
 * в браузерный бандл уезжала вся библиотека — при том, что validate()
 * не вызывался нигде и валидация фактически не работала.
 */
export const EnvValidateConfig = {
  REACT_APP_API_URI: {required: true, uri: true},
  REACT_APP_SECRET_PASSWORD: {required: true}
} satisfies Record<string, EnvRule>
